import React, { useState } from 'react';
import { Autocomplete, TextField } from '@mui/material';

interface ShowLocationPickerProps {
  value: string;
  onChange: (event: any) => void;
  chartType: 'bubble' | 'filled';
}

const ShowLocationPicker = ({ value, onChange, chartType }: ShowLocationPickerProps) => {
  const [options] = useState<string[]>([
    'World',
    'World Cities',
    'Australia',
    'Australia Cities',
    'Austria',
    'Austria Cities',
    'Argentina',
    'Argentina Cities',
    'Brazil',
    'Brazil Cities',
    'Belgium',
    'Belgium Cities',
    'Canada',
    'Canada Cities',
    'China',
    'China Cities',
    'France',
    'France Cities',
    'Germany',
    'Germany Cities',
    'India',
    'Indian Cities',
    'Indonesia',
    'Indonesia Cities',
    'Ireland',
    'Ireland Cities',
    'Israel',
    'Israel Cities',
    'Italy',
    'Italy Cities',
    'Japan',
    'Japan Cities',
    'Mexico',
    'Mexico Cities',
    'Malaysia',
    'Malaysia Cities',
    'Norway',
    'Norway Cities',
    'Nigeria',
    'Nigeria Cities',
    'Philippines',
    'Philippines Cities',
    'Poland',
    'Poland Cities',
    'Russia',
    'Russia Cities',
    'Saudi Arabia',
    'Saudi Arabia Cities',
    'South Africa',
    'South Africa Cities',
    'South Korea',
    'South Korea Cities',
    'Spain',
    'Spain Cities',
    'Sweden',
    'Sweden Cities',
    'Singapore',
    'Singapore Cities',
    'Switzerland',
    'Switzerland Cities',
    'Turkey',
    'Turkey Cities',
    'Thailand',
    'Thailand Cities',
    'UAE',
    'UAE Cities',
    'UK',
    'UK Cities',
    'USA',
    'USA Cities',
    'Vietnam',
    'Vietnam Cities',
  ]);

  const filteredOptions =
    chartType === 'filled'
      ? options.filter((option: string) => !option.toLowerCase().includes('cities'))
      : options;

  return (
    <div
      style={{
        display: 'flex',
        flexDirection: 'column',
        padding: '10px 12px 0 12px',
      }}
    >
      <span className="axisTitle"></span>
      <div>
        <Autocomplete
          defaultValue={'World'}
          value={value}
          disablePortal
          id="combo-box-demo"
          onChange={(e: React.SyntheticEvent, value: any) => {
            onChange(value);
          }}
          options={filteredOptions}
          sx={{
            color: '#2bb9bb',
            width: '100%',
            boxSizing: 'border-box',
            '& .MuiAutocomplete-inputRoot': {
              maxHeight: '32px !important',
              paddingRight: '30px !important',
            },
            '& .MuiOutlinedInput-root': {
              paddingRight: '8px',
              paddingLeft: '0px',
            },
            '& .css-y0cxhw-MuiFormLabel-root-MuiInputLabel-root': {
              top: '-12px',
              fontSize: '12px',
            },
            '& .Mui-focused .MuiOutlinedInput-notchedOutline': {
              borderColor: '#2bb9bb !important',
              color: '#2bb9bb !important',
            },
            '& .MuiInputLabel-root.Mui-focused': {
              borderColor: '#2bb9bb !important',
              color: '#2bb9bb !important',
            },
            '&:hover .MuiOutlinedInput-notchedOutline': {
              borderColor: '#2bb9bb !important',
              color: '#2bb9bb !important',
            },
          }}
          renderInput={(params) => (
            <TextField
              {...params}
              label="Select Map"
              InputLabelProps={{ ...params.InputLabelProps, shrink: true }}
              sx={{
                '& .MuiInputBase-root': {
                  height: '25px',
                  borderRadius: '4px',
                  padding: '0 8px',
                },
                '& .MuiOutlinedInput-input': {
                  textAlign: 'start', //************* */
                  height: '25px !important',
                  paddingLeft: '10px !important',
                  fontSize: '13px',
                },
                '& .MuiSvgIcon-root': {
                  fontSize: '18px',
                },
                '& .MuiAutocomplete-clearIndicator': {
                  padding: 0,
                  '& .MuiSvgIcon-root': {
                    fontSize: '15px',
                  },
                },
                '& .css-1d4y7n0-MuiSvgIcon-root': {
                  fontSize: '13px',
                },
              }}
            />
          )}
          ListboxProps={{
            sx: {
              "& .MuiAutocomplete-option[aria-selected='true']": {
                backgroundColor: 'rgba(43, 185, 187, 0.1) !important',
                color: 'black',
              },
              "& .MuiAutocomplete-option[aria-selected='true']:hover": {
                backgroundColor: 'rgba(43, 185, 187, 0.2) !important',
              },
            },
          }}
        />
      </div>
    </div>
  );
};

export default ShowLocationPicker;
